import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The session id moves into the apps splat route's search params — the splat
 * exposes no named params — so an old bookmark still opens its conversation.
 */
export const Route = createFileRoute('/$slug/omniscient/$sessionId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$slug/apps/$',
      params: { slug: params.slug, _splat: 'omniscient' },
      search: { sessionId: params.sessionId },
      replace: true
    });
  }
});
